import { AxiosRequestConfig } from "axios";
import api from "../api-instance";
import { SqlQueryInfo } from "../../../modules/sqlQueries/types";

const ROUTE = "/Queries";

export async function getSqlQueries(): Promise<{
  data: GetSqlQueriesResponse;
}> {
  const config: AxiosRequestConfig = {};
  const response = await api.get(`${ROUTE}/get-sql-queries`, config);
  return {
    data: response.data.result,
  };
}
export type GetSqlQueriesResponse = {
  relatorioMensalQueries: SqlQueryInfo[];
  relatorioDiarioQueries: SqlQueryInfo[];
  dashboardQueries: SqlQueryInfo[];
};

export async function executeSqlQuery(
  request: ExecuteSqlQueryRequest
): Promise<{ data: ExecuteSqlQueryResponse }> {
  const config: AxiosRequestConfig = {};
  const response = await api.post(
    `${ROUTE}/execute-sql-query`,
    request,
    config
  );
  return {
    data: response.data,
  };
}

export type ExecuteSqlQueryResponse = {
  executedQuery: SqlQueryInfo;
};

export type ExecuteSqlQueryRequest = {
  usinaId: number;
  queryId: string;
  referenceDate: string;
};
